let BASE_URL = "https://contractor.aimantra.info";
let IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
let TEST_URL = "https://n00nmkv7-8001.inc1.devtunnels.ms";
// BASE_URL = "https://5rn0m63d-8001.inc1.devtunnels.ms/";
const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

const AUTH_JSON = {
    headers: {
        Authorization: sessionStorage.getItem("access_token")
            ? "Bearer " + sessionStorage.getItem("access_token")
            : null,
        "Content-Type": "application/json",
        accept: "application/json",
    },
};

const AUTH_Multipart = {
    headers: {
        Authorization: sessionStorage.getItem("access_token")
            ? "Bearer " + sessionStorage.getItem("access_token")
            : null,
        "Content-Type": "multipart/form-data",
    },
};

export { BASE_URL, IMAGE_URL, TEST_URL, FRONTEND_URL, AUTH_JSON, AUTH_Multipart };